import dayjs from 'dayjs';
import {
  Selbstbeteiligung,
  SpartenType,
  Tiergeschlecht,
  Zahlungsart,
  Zahlweise,
} from '@ps20/bff-models';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { TierartEnum } from '@ps20-frontend/frontend-models';
import { IAppState } from './appState';
import { DogBreedType } from './reducers/versicherungsnehmer.reducer';
import { CoverageType } from './models/vertragsoptionen.model';

export const INITIAL_STATE: IAppState = {
  version: 2,
  transientState: {
    role: null,
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: false,
    productLoadingIsInProgress: false,
    priceGuarantee: null,
    fehlerCodeTaas: '',
    featureToggles: {},
    regexps: {},
    kooperationen: null,
  },
  produkt: {
    produktlinien: [],
    uebergreifend: [],
    spartenType: SpartenType.TIERKRANKEN_V2,
    hspLfnr: null,
  },
  versicherungsnehmer: {
    geburtsdatum: null,
    isAssekuranztarif: false,
    juristisch: false,
    animalType: TierartEnum.HUND,
    animalGender: Tiergeschlecht.MAENNLICH,
    animalName: '',
    animalBirthDate: null,
    dogBreeds: null,
    horseBreeds: null,
    catBreeds: null,
    breed: null,
    dogBreedType: DogBreedType.SELECTED,
    animalIllnesses: null,
    hasIllnesses: null,
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
  },
  vorbelegungen: {
    versicherungsnehmerVorbelegt: false,
    adresseImmobilieVorbelegt: false,
  },
  vertragsoptionen: {
    coverageType: CoverageType.OPSCHUTZ,
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
    hasWechselbaustein: null,
  },
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  rabattstufe: null,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  antragsnummer: '',
};
